<template>
    <DModal
        v-model="form.activity_log_comment"
        :title="__('customers.contracts.cancel_contract_title')"
        :message="__('customers.contracts.cancel_contract_message')"
        is-confirm
        is-error
        :show="showModal || modalHasErrors"
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        @confirm="cancelConfirm"
        @close="$emit('close-modal')"
        @clearFields="resetCancelForm()"
    />
</template>

<script>
export default {
    name: 'CancelContractModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        errorsData: {
            type: Object,
            default: () => { return {} }
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal'],
    data () {
        return {
            form: this.$inertia.form({
                activity_log_comment: null
            }),
            errors: this.errorsData,
            modalHasErrors: false
        }
    },
    methods: {
        cancelConfirm () {
            this.form.post(this.$route('customers.customers.contracts.cancel-contract', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                filters: this.filters
            }), {
                onSuccess: () => {
                    this.$emit('close-modal')
                    this.resetCancelForm()
                    this.modalHasErrors = false
                },
                onError: (error) => {
                    this.errors = error
                    this.modalHasErrors = true
                }
            })
        },
        resetCancelForm () {
            this.form.reason = null
            this.errors = {}
        }
    }
}
</script>
